import { render, staticRenderFns } from "./InactiveAccounts.vue?vue&type=template&id=b7da26a8&scoped=true&"
import script from "./InactiveAccounts.vue?vue&type=script&lang=js&"
export * from "./InactiveAccounts.vue?vue&type=script&lang=js&"
import style0 from "./InactiveAccounts.vue?vue&type=style&index=0&id=b7da26a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7da26a8",
  null
  
)

export default component.exports